import { useGlobalPermissions } from '@lopo-tech/lopo-api'
import React, { useContext } from 'react'
import { useHistory } from 'react-router'
import { Button } from 'src/components/button/button'
import { SvgIcon } from 'src/components/icons/svg-icon'
import { CLASS_PREFIX } from 'src/constants/'
import { FRONTEND_CREATE_PROFILE, FRONTEND_GROUP_PATH } from 'src/constants/urls'
import { URLContext } from 'src/containers/url_provider/url_provider'
import { textResources } from 'src/lang/de'
import { AUTH_CLS } from '../../auth/constants'
import './signup_complete.scss'

const cls = `${CLASS_PREFIX}signup-complete`

type IProps = {
  closeModal: () => void
  isPublicProfileFlow: boolean
  onCloseModal: () => void
}

export const SignupComplete: React.FC<IProps> = ({ closeModal, isPublicProfileFlow, onCloseModal }) => {
  const { canShowAuthorityProfilesList, canShowBlogProfilesList, canShowPressProfilesList, canRequestGroup, canCreateBlogProfile } = useGlobalPermissions()
  const history = useHistory()

  const {
    getProfilesDirectoryRoute
  } = useContext(URLContext)

  const onCreatePublicProfile = () => {
    onCloseModal()
    history.push(`${FRONTEND_CREATE_PROFILE}/profile`)
  }

  const onFollowProfiles = () => {
    onCloseModal()
    history.push(getProfilesDirectoryRoute())
  }

  const onJoinGroup = () => {
    onCloseModal()
    // workaround for redirect happening when the profile id is committed (location shape is undefined for a moment)
    setTimeout(() => {
      history.push(FRONTEND_GROUP_PATH)
    }, 500)
  }

  if (isPublicProfileFlow) {
    return (
      <div className={cls}>
        <div className={`${cls}__content`}>
          <div className={`${cls}__header`}>
            <div className={`${cls}__success-icon`}>
              <SvgIcon name="General/check" size={48} />
            </div>
            <div className={`${cls}__private-title`}>
              {textResources.authentication.signupCompleteAlmostDone}
            </div>
            <div className={`${AUTH_CLS}__subheader`}>
              {textResources.authentication.signupCompletePublicProfileSubtitle}
            </div>
          </div>
          <Button
            className={`${cls}__cta`}
            size="large"
            title={textResources.authentication.signupCompleteCreatePublicProfile}
            onClick={onCreatePublicProfile}
          />
        </div>
      </div>
    )
  }

  const canFollowProfiles = canShowAuthorityProfilesList || canShowBlogProfilesList || canShowPressProfilesList
  const hasAnyCta = canCreateBlogProfile || canFollowProfiles || canRequestGroup

  if (!hasAnyCta) {
    return (
      <div className={cls}>
        <div className={`${cls}__content`}>
          <div className={`${cls}__header`}>
            <div className={`${cls}__success-icon`}>
              <SvgIcon name="General/check" size={48} />
            </div>
            <div className={`${cls}__private-title`}>{textResources.authentication.signupCompleteAllSet}</div>
          </div>
          <Button
            className={`${cls}__cta`}
            size="large"
            title={textResources.authentication.signupCompleteExplore}
            onClick={closeModal}
          />
        </div>
      </div>
    )
  }

  return (
    <div className={cls}>
      <div className={`${cls}__content`}>
        <div className={`${cls}__header`}>
          <div className={`${cls}__success-icon`}>
            <SvgIcon name="General/check" size={48} />
          </div>
          <div className={`${cls}__private-title`}>
            {textResources.authentication.signupCompleteAllSet}
          </div>
        </div>
        <div className={`${cls}__tiles`}>
          {canCreateBlogProfile && (
            <>
              <div className={`${cls}__option`} onClick={onCreatePublicProfile}>
                <div className={`${cls}__option-icon-left`}>
                  <SvgIcon name="General/building-04" size={20} gradient />
                </div>
                <div className={`${cls}__option-content`}>
                  <div className={`${cls}__option-title`}>
                    {textResources.authentication.signupCompleteCreatePage}
                  </div>
                  <div className={`${cls}__option-subtitle`}>
                    {textResources.authentication.signupCompleteCreatePageSubtitle}
                  </div>
                </div>
                <div className={`${cls}__option-icon-right`}>
                  <SvgIcon name="Arrows/chevron-right" size={20} />
                </div>
              </div>
              <div className={`${cls}__option-divider`}></div>
            </>
          )}
          {canFollowProfiles && (
            <>
              <div className={`${cls}__option`} onClick={onFollowProfiles}>
                <div className={`${cls}__option-icon-left`}>
                  <SvgIcon name="Users/user-plus-01" size={20} gradient />
                </div>
                <div className={`${cls}__option-content`}>
                  <div className={`${cls}__option-title`}>
                    {textResources.authentication.signupCompleteFollowProfile}
                  </div>
                  <div className={`${cls}__option-subtitle`}>
                    {textResources.authentication.signupCompleteFollowProfileSubtitle}
                  </div>
                </div>
                <div className={`${cls}__option-icon-right`}>
                  <SvgIcon name="Arrows/chevron-right" size={20} />
                </div>
              </div>
              <div className={`${cls}__option-divider`}></div>
            </>
          )}
          {canRequestGroup && (
            <>
              <div className={`${cls}__option`} onClick={onJoinGroup}>
                <div className={`${cls}__option-icon-left`}>
                  <SvgIcon name="Users/users-03" size={20} gradient />
                </div>
                <div className={`${cls}__option-content`}>
                  <div className={`${cls}__option-title`}>
                    {textResources.authentication.signupCompleteJoinGroup}
                  </div>
                  <div className={`${cls}__option-subtitle`}>
                    {textResources.authentication.signupCompleteJoinGroupSubtitle}
                  </div>
                </div>
                <div className={`${cls}__option-icon-right`}>
                  <SvgIcon name="Arrows/chevron-right" size={20} />
                </div>
              </div>
              <div className={`${cls}__option-divider`}></div>
            </>
          )}
        </div>
        <Button
          size="large"
          title={textResources.authentication.signupCompleteExplore}
          onClick={closeModal}
        />
      </div>
    </div>
  )
}
